import { useState } from "react";
import { Link } from "react-router";
import { t } from '../locales/translate.js';

function Element({ apiCall }) {
    const [email, setEmail] = useState("");
    const [resetCode, setResetCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [password] = useState("");
    const [error, setError] = useState(null);
    const [passwordReset, setPasswordReset] = useState(false);

    // send data to API on form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const { response, error } = await apiCall("POST", "password/forgot", { email, password });

        if (error) {
            setError(error);
            return;
        }

        if (response && response.message) {
            if (response.message === "Reset code sent to your email.") {
                setPasswordReset(true);
            }
        } else {
            setError(t('login_failed_check_credentials'));
        }

    };

    const handleResetSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (newPassword !== confirmPassword) {
            setError(t('passwords_do_not_match_error'));
            return;
        }

        const data = {
            'email': email,
            'code': resetCode,
            'password': newPassword,
            'password_confirmation': confirmPassword
        };

        const { response, error } = await apiCall("POST", "password/reset", data);

        if (error) {
            setError(error);
            return;
        }

        if (response && response.message) {
            if (response.message === "Password has been reset successfully.") {
                // Redirect to login page after successful password reset
                window.location.href = '/login';
            }
        } else {
            setError(t('password_reset_failed'));
        }
    };

    if (passwordReset) {
        return (
            <div className="row m-0">
                <div className="col-12 p-0">
                    <div className="login-card login-dark">

                        <div className="login-main">
                            <form className="theme-form" onSubmit={(e) => handleResetSubmit(e)}>
                                <h4>{t('reset_password')}</h4>
                                <p>{t('reset_password_instructions')}</p>
                                <div className="form-group">
                                    <label className="col-form-label">{t('reset_code')}</label>
                                    <input className="form-control" type="text" required placeholder={t('enter_reset_code')} value={resetCode} onChange={(e) => setResetCode(e.target.value)} autoComplete="off" />
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">{t('new_password')}</label>
                                    <div className="form-input position-relative">
                                        <input className="form-control" type="password" name="new-password" required placeholder={t('password_placeholder')} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="off" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">{t('confirm_new_password')}</label>
                                    <div className="form-input position-relative">
                                        <input className="form-control" type="password" name="confirm-password" required placeholder={t('password_placeholder')} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete="off" />
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="clearfix"></div>
                                    <div className="text-end">
                                        <button className="btn btn-primary btn-block w-100 mt-3" type="submit">{t('send')}</button>
                                    </div>
                                </div>
                                <p className="mt-4 mb-0">{t('already_have_account')}<Link className="ms-2" to="/login">{t('sign_in')}</Link></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className="row m-0">
            <div className="col-12 p-0">
                <div className="login-card login-dark">

                    <div className="login-main">
                        <form className="theme-form" onSubmit={(e) => handleSubmit(e)}>
                            <h4>{t('forgot_password')}</h4>
                            <p>{t('forgot_password_instructions')}</p>
                            <div className="form-group">
                                <label className="col-form-label">{t('email_address')}</label>
                                <input className="form-control" type="email" required placeholder={t('email_placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} />

                            </div>

                            <div className="form-group mb-0">

                                {error && <div className="alert alert-danger mt-2">{error}</div>}
                                <div className="clearfix"></div>
                                <div className="text-end">
                                    <button className="btn btn-primary btn-block w-100 mt-3" type="submit">{t('send')}</button>
                                </div>
                            </div>

                            <p className="mt-4 mb-0">{t('already_have_account')}<Link className="ms-2" to="/login">{t('sign_in')}</Link></p>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Element;
